$.fn.validateInput = function (checkEmpty) {
    $(this).removeClass("state--invalid state--valid");
    if ($(this).find("input, textarea").val() !== "" || checkEmpty) {
        if ($(this).find("input, textarea").is(":valid")) {
            $(this).addClass("state--valid");
        } else {
            $(this).addClass("state--invalid");
        }
    }
};